import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormService } from '../../features/booking/components/form/service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { DateTimeFlightPickerComponent } from '../../../datetimeflight-picker/datetimeflight-picker.component';
import { CommonModule, DatePipe } from '@angular/common';
import { RouteParamService } from '../../../services/route-param.service';
import { SimpleSearchSelectComponent } from '../../../components/simple-search-select/simple-search-select.component';
import { format } from 'date-fns';
import { FormControl } from '@angular/forms';
import { TextInputDataComponent } from "../../../components/text-input/text-input.component";
import { BookingConfigService } from '../../../services/booking-config.service';
import { TopNavbarComponent } from '../../components/top-navbar/top-navbar.component';
import { SelfServiceService } from '../../../../services/self-service.service';
import { WelcomeComponent } from '../../../components/welcome/welcome.component';
import { AuthService } from '../../../../../app/services/auth.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MaintenanceService } from '../../../../services/maintenance.service';
import { LoginService } from '../../../../services/login.service';

@Component({
  selector: 'app-home-component',
  imports: [
    CommonModule,
    TranslocoModule,
    DateTimeFlightPickerComponent,
    SimpleSearchSelectComponent,
    TextInputDataComponent,
    TopNavbarComponent,
    WelcomeComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [FormService, DatePipe]
})
export class HomeComponent {

  site: string = '';
  activeTab: string = "book";

  arrivalFlight: any;
  departureFlight: any;

  arrivalFlightDate: any;
  departureFlightDate: any;

  hotelArrivalDatetime: any;
  hotelDepartureDatetime: any;

  parkingArrivalTime: any;

  arrivalHotel: any;
  departureHotel: any;

  isArrivalHotel: any;
  isDepartureHotel: any;

  parkingStartTime: any;
  parkingEndTime: any;

  selectType: string = '';

  private _organization: string = '';

  searchData: any;

  routerState: any;

  discountCodeControl: FormControl = new FormControl('');
  flightTimeWarning: boolean = false;
  isLoggedIn: boolean = false;
  parkingOperators: any[] = [];
  orgId: any = '';
  showToggle: any = false;

  constructor(
    private router: Router,
    private _formService: FormService,
    private _datePipe: DatePipe,
    private route: ActivatedRoute,
    private routeParamService: RouteParamService,
    private _router: Router,
    private bookingConfigService: BookingConfigService,
    private selfServiceService: SelfServiceService,
    public authService: AuthService,
    private dialog: MatDialog,
    private maintenanceService: MaintenanceService,
    private loginService: LoginService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
    this.selectType = config.searchSelect;
    this.orgId = config.orgId;

    sessionStorage.removeItem('isParkingPermitUser');
    sessionStorage.removeItem('isQuality2daysBooking');
    sessionStorage.removeItem('isAiden2daysBooking');

    this._formService.initForm(this.site);

    const routerState = this._router.getCurrentNavigation();
    const navState = routerState?.extras?.state || history.state;

    if (navState && (navState.departureDate || navState.arrivalDate || navState.searchData || navState.selectedParking)) {
      this.searchData = navState.searchData ? navState.searchData : navState;
      if (navState.selectedParking) {
        this._formService.selectedParking = navState.selectedParking;
      } else {
        this._formService.selectedParking = null;
        sessionStorage.removeItem('selectedParkingFromSearch');
        sessionStorage.removeItem('isFromCustomerHome');
      }
      if (this.searchData) {
        this.parkingStartTime = this.searchData.departureDate;
        this.parkingEndTime = this.searchData.arrivalDate;
        const initialDiscount = this.searchData?.discountCode;
        if (initialDiscount && initialDiscount.toUpperCase() !== 'NONE' && initialDiscount !== 'null') {
          this.discountCodeControl.setValue(initialDiscount);
        } else {
          this.discountCodeControl.setValue('');
        }
      }
    } else {
      this._formService.selectedParking = null;
      sessionStorage.removeItem('selectedParkingFromSearch');
      sessionStorage.removeItem('isFromCustomerHome');
    }

    this.route.queryParamMap.subscribe(params => {
      const discountParam = params.get('discount_code') || params.get('discountCode');
      if (discountParam) {
        if (discountParam.toUpperCase() === 'NONE' || discountParam === 'null') {
          this.discountCodeControl.setValue('');
        } else {
          this.discountCodeControl.setValue(discountParam);
        }
      }
    });

    if (this.site === 'nazar') {
      this.discountCodeControl.setValue('nazar');
      this.discountCodeControl.disable();
    }

    if (this.site === 'tui') {
      this.discountCodeControl.setValue('TUI10');
      this.discountCodeControl.disable();
    }

  }

  ngOnInit(): void {
    this.checkMaintenanceTime();

    if (!this.authService.loggedIn() && this.loginService.showPopupValue === true) {
      this.dialog.open(WelcomeComponent, {
        width: '500px',
        disableClose: false,
        panelClass: 'welcome-dialog'
      });
    }

    const stateData = history.state;
    if (stateData && (stateData.departureDate || stateData.arrivalDate)) {
      const departureDate = stateData.departureDate ? new Date(stateData.departureDate) : null;
      const arrivalDate = stateData.arrivalDate ? new Date(stateData.arrivalDate) : null;

      if (departureDate) this.parkingStartTime = departureDate;
      if (arrivalDate) this.parkingEndTime = arrivalDate;

      this.searchData = {
        ...(this.searchData || {}),
        ...stateData,
        departureDate: departureDate || this.searchData?.departureDate,
        arrivalDate: arrivalDate || this.searchData?.arrivalDate,
        flightDepartureDate: departureDate || this.searchData?.flightDepartureDate,
        arrivalFlightDate: arrivalDate || this.searchData?.arrivalFlightDate,
        departureFlightDate: departureDate || this.searchData?.departureFlightDate
      };

      const searchGroup = this._formService.getForm()?.get('search');
      if (searchGroup) {
        searchGroup.patchValue({
          departureFlightDate: departureDate,
          arrivalFlightDate: arrivalDate,
          departureDatetime: departureDate,
          arrivalDatetime: arrivalDate
        });
      }
    }

    this.route.queryParams.subscribe(params => {
      const fromVal = params['from'] || params['parking_start'] || params['departureDate'];
      const toVal = params['to'] || params['parking_end'] || params['arrivalDate'];

      if (fromVal || toVal) {
        const departureDate = fromVal ? new Date(fromVal) : null;
        const arrivalDate = toVal ? new Date(toVal) : null;

        if (departureDate) this.parkingStartTime = departureDate;
        if (arrivalDate) this.parkingEndTime = arrivalDate;

        this.searchData = {
          ...(this.searchData || {}),
          departureDate: departureDate || this.searchData?.departureDate,
          arrivalDate: arrivalDate || this.searchData?.arrivalDate,
          flightDepartureDate: departureDate || this.searchData?.flightDepartureDate,
          arrivalFlightDate: arrivalDate || this.searchData?.arrivalFlightDate,
          departureFlightDate: departureDate || this.searchData?.departureFlightDate
        };

        const searchGroup = this._formService.getForm()?.get('search');
        if (searchGroup) {
          searchGroup.patchValue({
            departureFlightDate: departureDate,
            arrivalFlightDate: arrivalDate,
            departureDatetime: departureDate,
            arrivalDatetime: arrivalDate
          });
        }
      }

      if (params['discountCode'] || params['discount_code']) {
        this.discountCodeControl.setValue(params['discountCode'] || params['discount_code']);
      }
    });

    this.route.paramMap.subscribe(params => {
      this._organization = params.get('organization') || "";
      this.routeParamService.setOrg(this._organization);

      this.bookingConfigService.setOrganizationFromUrl();

      this.site = this.bookingConfigService.getConfig().site;
      this.selectType = this.bookingConfigService.getConfig().searchSelect;

      this._formService.initForm(this.site);
    });

    if (this.selectType == 'advanced') {

      const search = this._formService.getForm().get('search');
      const flights = this._formService.getForm().get('flights');
      const hotels = this._formService.getForm().get('hotels');

      flights.controls.arrivalFlight.valueChanges.subscribe((value: any) => {
        this.arrivalFlight = value;
      });
      flights.controls.departureFlight.valueChanges.subscribe((value: any) => {
        this.departureFlight = value;
      });

      search.controls.arrivalFlightDate.valueChanges.subscribe((value: any) => {
        this.arrivalFlightDate = value;
      });
      search.controls.departureFlightDate.valueChanges.subscribe((value: any) => {
        this.departureFlightDate = value;
      });

      search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
        this.arrivalFlightDate = value;

      });
      search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
        this.parkingArrivalTime = value;
      });

      hotels.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
        this.hotelArrivalDatetime = value;

      });
      hotels.controls.departureDatetime.valueChanges.subscribe((value: any) => {
        this.hotelDepartureDatetime = value;
      });

      hotels.controls.arrivalHotel.valueChanges.subscribe((value: any) => {
        this.arrivalHotel = value;
      });
      hotels.controls.departureHotel.valueChanges.subscribe((value: any) => {
        this.departureHotel = value;
      });

      search.controls.isArrivalHotel.valueChanges.subscribe((value: any) => {
        this.isArrivalHotel = value;
      });
      search.controls.isDepartureHotel.valueChanges.subscribe((value: any) => {
        this.isDepartureHotel = value;
      });
    }

    if (this.selectType == 'simple') {
      const search = this._formService.getForm().get('search');

      search.controls.arrivalDatetime.valueChanges.subscribe((value: any) => {
        this.parkingEndTime = value;
      })
      search.controls.departureDatetime.valueChanges.subscribe((value: any) => {
        this.parkingStartTime = value;
      })
    }

    if (this.authService.loggedIn()) {
      this.isLoggedIn = true;
      this.loadParkingOperators();
    }

    this.authService.getUserLoginObservable().subscribe(isLoggedIn => {
      this.isLoggedIn = isLoggedIn;
      if (isLoggedIn) {
        this.loadParkingOperators();
      } else {
        this.showToggle = false;
        sessionStorage.removeItem('showSubscription');
      }
    });

  }

  get isContinueButtonEnabled(): boolean {

    if (this.selectType == 'advanced') {

      let isArrivalComplete = false;
      let isDepartureComplete = false;

      if (this.isArrivalHotel) {
        isArrivalComplete = this.arrivalHotel && this.hotelArrivalDatetime;
      } else {
        isArrivalComplete = this.arrivalFlight && this.arrivalFlightDate;
      }

      if (this.isDepartureHotel) {
        isDepartureComplete = this.departureHotel && this.hotelDepartureDatetime;
      } else {
        isDepartureComplete = this.departureFlight && this.parkingArrivalTime;
      }

      if (this.arrivalFlight && this.departureFlight) {

        const depTime = new Date(this.departureFlight?.departureTime?.scheduled)?.getTime();
        const arrTime = new Date(this.arrivalFlight?.arrivalTime?.scheduled)?.getTime();

        if (arrTime < depTime) {
          this.flightTimeWarning = true;
        } else {
          this.flightTimeWarning = false;
        }
      }

      return isArrivalComplete && isDepartureComplete && this.flightTimeWarning == false;
    } else if (this.selectType == 'simple') {
      if (JSON.parse(sessionStorage.getItem('showSubscription')) == true) {
        const date = new Date(this.parkingStartTime);
        this.parkingEndTime = new Date(date?.getTime() + 30 * 24 * 60 * 60 * 1000);
        return this.parkingStartTime && this.parkingEndTime && this.parkingEndTime > this.parkingStartTime
      }
      return this.parkingStartTime && this.parkingEndTime && this.parkingEndTime > this.parkingStartTime
    }
    return false;
  }

  goToBookingForm() {
    if (this.authService.loggedIn()) {
      this.navigateToBooking();
    } else {
      if (this.loginService.showPopupValue === false) {
        this.navigateToBooking();
      }
      else {
        const dialogRef = this.dialog.open(WelcomeComponent, {
          width: '500px',
          disableClose: false,
          panelClass: 'welcome-dialog'
        });

        dialogRef.afterClosed().subscribe(() => {
          this.navigateToBooking();
        });
      }
    }
  }

  navigateToBooking() {
    if (this.selectType == 'advanced') {

      const hotels = this._formService.getForm().get('hotels');
      const flights = this._formService.getForm().get('flights');
      const search = this._formService.getForm().get('search');

      let parking_start = this._formService.searchStartDate;
      let parking_end = this._formService.searchEndDate;

      let arrival_flight = this._formService.selectedArrivalFlight;
      let departure_flight = this._formService.selectedDepartureFlight.getValue();

      parking_start = this._datePipe.transform(parking_start, 'yyyy-MM-dd HH:mm');
      parking_end = this._datePipe.transform(parking_end, 'yyyy-MM-dd HH:mm');

      if (this._formService.getForm().get('search').controls.isArrivalHotel.value) {
        parking_end = this._formService.getForm().get('hotels').controls.arrivalDatetime.value;
        parking_end = this._datePipe.transform(parking_end, 'yyyy-MM-dd HH:mm');
        arrival_flight = null;
      } else {
        hotels.controls.arrivalDatetime = null;
        hotels.controls.arrivalHotel = null;
        this._formService.arrivalHotel = null;
      }
      if (this._formService.getForm().get('search').controls.isDepartureHotel.value) {
        parking_start = this._formService.getForm().get('hotels').controls.departureDatetime.value;
        parking_start = this._datePipe.transform(parking_start, 'yyyy-MM-dd HH:mm');
        departure_flight = null;
      } else {
        hotels.controls.departureDatetime = null;
        hotels.controls.departureHotel = null;
        this._formService.departureHotel = null;
      }
      let departure_hotel = this._formService.departureHotel || null;
      let arrival_hotel = this._formService.arrivalHotel || null;

      let searchData = {
        //arrival
        arrivalFlightDate: search.controls.arrivalFlightDate?.value,
        arrivalFlight: flights.controls.arrivalFlight?.value,
        arrivalDatetime: search.controls.arrivalDatetime?.value,

        arrivalHotel: hotels.controls.arrivalHotel?.value,
        hotelArrivalDate: hotels.controls.arrivalDatetime?.value,
        hotelArrivalDatetime: hotels.controls.arrivalDatetime?.value,

        //departure
        hotelDepartureDate: hotels.controls.departureDatetime?.value,
        departureHotel: hotels.controls.departureHotel?.value,
        hotelDepartureDatetime: hotels.controls.departureDatetime?.value,

        departureFlight: flights.controls.departureFlight?.value,
        departureFlightDate: search.controls.departureFlightDate?.value,
        departureDatetime: search.controls.departureDatetime?.value,
      }

      let queryParams: any = {
        parking_start: parking_start || undefined,
        parking_end: parking_end || undefined,
      };

      if (this.discountCodeControl.value && this.discountCodeControl.value.trim().toUpperCase() !== 'NONE') {
        queryParams['discount_code'] = this.discountCodeControl.value;
      }

      this.router.navigate(['parkifly', this.site, 'booking', queryParams],
        {
          state: {
            arrival_flight,
            departure_flight,
            departure_hotel,
            arrival_hotel,
            searchData,
            org: this._organization || this.site,
            selectedParking: this.searchData?.selectedParking || this._formService.selectedParking || history.state?.selectedParking
          }
        }
      );
    }
    else if (this.selectType == 'simple') {
      const search = this._formService.getForm().get('search');
      let parking_start = format(this.parkingStartTime, 'yyyy-MM-dd HH:mm')
      let parking_end = format(this.parkingEndTime, 'yyyy-MM-dd HH:mm')
      let queryParams: any = {
        parking_start: parking_start || undefined,
        parking_end: parking_end || undefined,
      };
      if (this.discountCodeControl.value && this.discountCodeControl.value.trim().toUpperCase() !== 'NONE') {
        queryParams['discount_code'] = this.discountCodeControl.value;
      }
      this.router.navigate(['parkifly', this.site, 'booking', queryParams],
        {
          state: {
            selectedParking: this.searchData?.selectedParking || this._formService.selectedParking || history.state?.selectedParking
          }
        }
      );
    }
  }

  checkMaintenanceTime() {
    this.maintenanceService.checkMaintenanceTime();
  }

  loadParkingOperators() {
    this.selfServiceService.getParkingOperators('SWE').then((result) => {
      this.parkingOperators = result?.stations || [];
      const subscriptionExists = this.parkingOperators.some(station =>
        station.parkingOperators?.some(op => op.organizationId?.toLowerCase() == this.orgId?.toLowerCase() && op.subscriptionParking == true)
      );
      this.showToggle = subscriptionExists && this.isLoggedIn;
    });
  }

}

@Component({
  selector: 'app-maintenance-dialog',
  imports: [TranslocoModule],
  template: `
    <div class="maintenance-dialog">
    <div class="flex justify-center py-4">
        <svg width="106" height="117" viewBox="0 0 106 117" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M74.0049 23.325L58.7525 11.805C55.3515 9.23619 50.6589 9.2362 47.2578 11.805L32.0055 23.325L13.8482 29.8366C9.49901 31.3963 6.89367 35.8495 7.6651 40.405L10.6508 58.0367L7.6651 75.6684C6.89366 80.2239 9.49902 84.6771 13.8482 86.2368L32.0055 92.7484L47.2578 104.268C50.6589 106.837 55.3515 106.837 58.7525 104.268L74.0049 92.7484L92.1622 86.2368C96.5114 84.6771 99.1167 80.2239 98.3453 75.6684L95.3595 58.0367L98.3453 40.405C99.1167 35.8495 96.5114 31.3963 92.1622 29.8366L74.0049 23.325Z"
                fill="#FFEDE3" stroke="#FFF5F5" stroke-width="13.6229" />
            <circle cx="52" cy="57" r="10" stroke="#DC0032" stroke-width="2" fill="#FFEDEE" />
            <line x1="47" y1="52" x2="57" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />
            <line x1="57" y1="52" x2="47" y2="62" stroke="#DC0032" stroke-width="2" stroke-linecap="round" />

        </svg>
    </div>
      <h2>{{ 'MAINTENANCE.TITLE' | transloco }}</h2>
      <p>{{ 'MAINTENANCE.MESSAGE' | transloco }} {{ data?.endTime }}.</p>
      <div class="language-toggle">
            <div>
            <button class="
            w-[48px]
            h-[48px]
            " (click)="toggleLanguage()" style="outline: none;">
                <img src="{{languageImageSource}}" alt="toggle language" class="w-[25px] h-[25px]">
            </button>
        </div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .maintenance-dialog {
      padding: 24px;
      text-align: center;
      position: relative;
    }
    h2 {
      margin-bottom: 16px;
      color: #f44336;
    }
  `]
})
export class MaintenanceDialogComponent {
  currentLang = 'sv';

  languageImageSources: { [key: string]: string } = {
    en: "../../../../../assets/img/flag-button-round-250-EN.png",
    sv: "../../../../../assets/img/flag-button-round-250-SV.png",
  };

  languageImageSource: string = '';

  constructor(private _translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: { endTime: string }
  ) {
    this.currentLang = this._translocoService.getActiveLang();
    this.languageImageSource = this.currentLang === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];
  }

  toggleLanguage() {

    let activeLanguage = this._translocoService.getActiveLang();

    if (activeLanguage == 'sv') {
      this._translocoService.setActiveLang('en');
    } else {
      this._translocoService.setActiveLang('sv');
    }

    activeLanguage = this._translocoService.getActiveLang();
    this.languageImageSource = activeLanguage === 'en' ? this.languageImageSources['sv'] : this.languageImageSources['en'];

  }
}